<div class="search-input-wrapper-outline">
    <label for="search" class="mr-8 search-label">
        <mat-icon class="secondary-text">search</mat-icon>
    </label>
    <mat-form-field floatLabel="never" appearance="outline" fxFlex="1 0 auto">
        <input matInput [formControl]="searchInput" class="search-input" [placeholder]="(label ? label : 'GENERAL.SEARCH') | translate" />
        <mat-icon *ngIf="searchInput.value" class="clear" (click)="searchInput.setValue('')">close</mat-icon>
    </mat-form-field>
</div>
